var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "changeblog" },
    [
      _c(
        "el-form",
        {
          ref: "addblog",
          attrs: {
            model: _vm.addblog,
            rules: _vm.rules,
            "status-icon": true,
            "hide-required-asterisk": "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "显示浏览数",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "9",
                    },
                    model: {
                      value: _vm.addblog.viewCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "viewCount", $$v)
                      },
                      expression: "addblog.viewCount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "浏览数", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: "",
                      autocomplete: "off",
                      type: "text",
                      maxlength: "9",
                    },
                    model: {
                      value: _vm.addblog.viewCountReal,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "viewCountReal", $$v)
                      },
                      expression: "addblog.viewCountReal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "显示评论数",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "9",
                    },
                    model: {
                      value: _vm.addblog.commentsCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "commentsCount", $$v)
                      },
                      expression: "addblog.commentsCount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "评论数", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      disabled: "",
                      maxlength: "9",
                    },
                    model: {
                      value: _vm.addblog.commentsCountReal,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "commentsCountReal", $$v)
                      },
                      expression: "addblog.commentsCountReal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "显示点赞数",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "9",
                    },
                    model: {
                      value: _vm.addblog.thumbsCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "thumbsCount", $$v)
                      },
                      expression: "addblog.thumbsCount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "点赞数", "label-width": _vm.formLabelWidth },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      disabled: "",
                      type: "text",
                      maxlength: "9",
                    },
                    model: {
                      value: _vm.addblog.thumbsCountReal,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "thumbsCountReal", $$v)
                      },
                      expression: "addblog.thumbsCountReal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题",
                    "label-width": _vm.formLabelWidth,
                    prop: "title",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.addblog.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "title", $$v)
                      },
                      expression: "addblog.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "作者",
                    "label-width": _vm.formLabelWidth,
                    prop: "author",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "40",
                    },
                    model: {
                      value: _vm.addblog.author,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "author", $$v)
                      },
                      expression: "addblog.author",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "博客版本",
                    "label-width": _vm.formLabelWidth,
                    prop: "authorCn",
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "ZH-CN" },
                      model: {
                        value: _vm.addblog.language,
                        callback: function ($$v) {
                          _vm.$set(_vm.addblog, "language", $$v)
                        },
                        expression: "addblog.language",
                      },
                    },
                    [_vm._v("中文版")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "EN" },
                      model: {
                        value: _vm.addblog.language,
                        callback: function ($$v) {
                          _vm.$set(_vm.addblog, "language", $$v)
                        },
                        expression: "addblog.language",
                      },
                    },
                    [_vm._v("英文版")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "JA" },
                      model: {
                        value: _vm.addblog.language,
                        callback: function ($$v) {
                          _vm.$set(_vm.addblog, "language", $$v)
                        },
                        expression: "addblog.language",
                      },
                    },
                    [_vm._v("日文版")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "推荐标志",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "Y" },
                      model: {
                        value: _vm.addblog.recommendFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.addblog, "recommendFlag", $$v)
                        },
                        expression: "addblog.recommendFlag",
                      },
                    },
                    [_vm._v("推荐")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "N" },
                      model: {
                        value: _vm.addblog.recommendFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.addblog, "recommendFlag", $$v)
                        },
                        expression: "addblog.recommendFlag",
                      },
                    },
                    [_vm._v("不推荐")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "pc图片", "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        action: "https://jsonplaceholder.typicode.com/posts/",
                        "show-file-list": false,
                        "before-upload": _vm.beforeUploadPicture1,
                      },
                    },
                    [
                      _vm.imageUrl1
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.imageUrl1 },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "移动端图片",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        action: "https://jsonplaceholder.typicode.com/posts/",
                        "show-file-list": false,
                        "before-upload": _vm.beforeUploadPicture2,
                      },
                    },
                    [
                      _vm.imageUrl2
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.imageUrl2 },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "commont" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "SEO标题",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addblog.seoTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "seoTitle", $$v)
                      },
                      expression: "addblog.seoTitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "SEO关键字",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addblog.seoKeyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.addblog, "seoKeyword", $$v)
                      },
                      expression: "addblog.seoKeyword",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "SEO描述", "label-width": _vm.formLabelWidth } },
            [
              _c("el-input", {
                attrs: { autocomplete: "off", type: "text" },
                model: {
                  value: _vm.addblog.seoDescription,
                  callback: function ($$v) {
                    _vm.$set(_vm.addblog, "seoDescription", $$v)
                  },
                  expression: "addblog.seoDescription",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("ul", [
            _c(
              "li",
              [
                _c("h5", [_vm._v("国内博客内容")]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "avatar-uploader",
                    staticStyle: { display: "none" },
                    attrs: {
                      action: "",
                      "http-request": _vm.to_upload_img,
                      "show-file-list": false,
                    },
                  },
                  [
                    _vm._v("\n          >\n          "),
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                      attrs: { id: "imgInput" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("quill-editor", {
                  ref: "myQuillEditor",
                  attrs: { options: _vm.editorOption, "show-word-limit": "" },
                  model: {
                    value: _vm.addblog.content,
                    callback: function ($$v) {
                      _vm.$set(_vm.addblog, "content", $$v)
                    },
                    expression: "addblog.content",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("h5", [_vm._v("国外博客内容")]),
                _vm._v(" "),
                _c("quill-editor", {
                  ref: "myQuillEditor1",
                  attrs: { options: _vm.editorOption1, "show-word-limit": "" },
                  model: {
                    value: _vm.addblog.awsContent,
                    callback: function ($$v) {
                      _vm.$set(_vm.addblog, "awsContent", $$v)
                    },
                    expression: "addblog.awsContent",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "put", staticStyle: {} },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.back("addblog")
                },
              },
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save("addblog")
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }